export const parseDayName = (day: string) => {
  switch (day) {
    case 'domingo':
      return 'Domingo'
    case 'segunda-feira':
      return 'Segunda'
    case 'terça-feira':
      return 'Terça'
    case 'terca-feira':
      return 'Terça'
    case 'quarta-feira':
      return 'Quarta'
    case 'quinta-feira':
      return 'Quinta'
    case 'sexta-feira':
      return 'Sexta'
    case 'sábado':
      return 'Sábado'
    case 'sabado':
      return 'Sábado'
    case 'Sunday':
      return 'Domingo'
    case 'Monday':
      return 'Segunda'
    case 'Tuesday':
      return 'Terça'
    case 'Wednesday':
      return 'Quarta'
    case 'Thursday':
      return 'Quinta'
    case 'Friday':
      return 'Sexta'
    case 'Saturday':
      return 'Sábado'
  }
}
